import { login, logout, getInfo, appSwitch } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { resetRouter, asyncRouterMap } from "@/router";

const getDefaultState = () => {
  // 刷新页面后 Vuex 会重置，从 localStorage 恢复 account_list
  let cachedAccountList = [];
  try {
    const raw = localStorage.getItem("account_list");
    if (raw) cachedAccountList = JSON.parse(raw);
  } catch (e) {
    cachedAccountList = [];
  }
  if (!Array.isArray(cachedAccountList)) cachedAccountList = [];

  return {
    token: getToken(),
    name: "",
    avatar: "",
    hotel_no: "",
    hotel_name: "",
    renter_no: "",
    account_list: cachedAccountList,
    menulist: []
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: state => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_MENULIST: (state, menulist) => {
    state.menulist = menulist;
  },
  SET_HOTEL_NO: (state, hotel_no) => {
    state.hotel_no = hotel_no;
  },
  SET_HOTEL_NAME: (state, hotel_name) => {
    state.hotel_name = hotel_name;
  },
  SET_RENTER_NO: (state, renter_no) => {
    state.renter_no = renter_no;
  },
  SET_ACCOUNT_LIST: (state, account_list) => {
    state.account_list = account_list || [];
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, code } = userInfo;
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, code: code })
        .then(response => {
          // 拦截器 return response.data，这里 response = API 响应体 {code, data, message}
          // 解构出嵌套 data 对象，里面有 token / account_list / hotel_no 等
          const { data } = response;
          let account_list = [];
          if (Array.isArray(data && data.account_list)) {
            account_list = data.account_list;
          } else if (Array.isArray(response.account_list)) {
            account_list = response.account_list;
          }

          const token = (data && data.token) || response.token;
          const config = (data && data.config) || response.config || {};

          localStorage.setItem("account_list", JSON.stringify(account_list));
          commit("SET_ACCOUNT_LIST", account_list);
          commit("SET_TOKEN", token);
          var template_style =
            config.template_style === undefined ||
            config.template_style === null
              ? 0
              : config.template_style;
          localStorage.setItem("template_style", template_style);
          setToken(token);
          resolve(); // promise（异步操作）的resolve：将对象的状态-->‘未完成’变为‘成功’
        })
        .catch(error => {
          reject(error); // promise（异步操作）的reject：将对象的状态-->‘未完成’变为‘失败’
        });
    });
  },

  // getApiToken
  getApiToken({ commit }, data) {
    commit("SET_TOKEN", data.data.token);
    setToken(data.data.token);
  },

  // 云端跳转 ticket 登录
  ticketLogin({ commit }, ticket) {
    return new Promise((resolve, reject) => {
      appSwitch(ticket)
        .then(response => {
          const d = (response && response.data) || {};
          if (!d.token) {
            reject(new Error("appSwitch 未返回 token"));
            return;
          }
          commit("SET_TOKEN", d.token);
          setToken(d.token);
          // 同时把用户基本信息也存好（permission.js 里 getInfo 会再拉一次，但先存着防止竞态）
          if (d.username) commit("SET_NAME", d.username);
          if (d.hotel_no) commit("SET_HOTEL_NO", d.hotel_no);
          if (d.hotel_name) commit("SET_HOTEL_NAME", d.hotel_name);
          if (d.renter_no) commit("SET_RENTER_NO", d.renter_no);
          resolve(d);
        })
        .catch(err => reject(err));
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(response => {
          const { data } = response;
          if (!data) {
            reject("Verification failed, please Login again.");
          }
          const realname = data.username;
          const hotel_no = data.hotel_no;
          const hotel_name = data.hotel_name || "";
          const renter_no = data.renter_no;
          // account_list 只从 login 接口返回，login 已经 commit 过 state.account_list
          // 这里继续写 localStorage + commit 确保持久化兜底
          const account_list = state.account_list || [];
          var menutree = data.menutree || [];
          var is_sys = data.is_sys || 0;
          var group_id = data.group_id || 0;
          localStorage.setItem("menutree", JSON.stringify(menutree));
          localStorage.setItem("is_sys", is_sys);
          localStorage.setItem("group_id", group_id);
          localStorage.setItem("hotel_no", hotel_no);
          localStorage.setItem("account_list", JSON.stringify(account_list));
          commit("SET_NAME", realname); // 存储
          commit("SET_HOTEL_NO", hotel_no);
          commit("SET_HOTEL_NAME", hotel_name);
          commit("SET_RENTER_NO", renter_no);
          commit("SET_ACCOUNT_LIST", account_list);
          commit("SET_AVATAR", "");
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  getPermissionMenuList({ commit }, tempmenulist) {
    console.log("挂载路由：", tempmenulist);
    /* console.log('原有路由：', asyncRouterMap) */
    const menulist = [];
    //  console.log(asyncRouterMap, tempmenulist.roles)
    // 一级菜单权限判断
    asyncRouterMap.forEach((row, i) => {
      // console.log(row, i, row.meta.pop)
      // 有在权限列表中，或pop=F不需要判断权限或是隐藏路由则挂载
      if (
        tempmenulist.roles.indexOf(row.name) > -1 ||
        row.meta.pop === "F" ||
        row.hidden === true
      ) {
        // console.log('存在：', row.name)
        const tempRow = row;
        tempRow.children_temp = [];
        if (row.children) {
          // console.log('row.children', row.children)

          // 二级菜单权限判断
          row.children.forEach((chRow, n) => {
            // 有在权限列表中，或pop=F不需要判断权限或是隐藏路由则挂载
            if (
              tempmenulist.roles.indexOf(chRow.name) > -1 ||
              chRow.meta.pop === "F" ||
              chRow.hidden === true
            ) {
              tempRow.children_temp.push(chRow);
            }
          });
        }

        if (tempRow.children_temp) tempRow.children = tempRow.children_temp;
        menulist.push(tempRow);
        // console.log('新的路由：', tempRow)
      }
    });
    commit("SET_MENULIST", menulist);
    return "";
  },

  /* convertTree(){

  }, */

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          removeToken(); // must remove  token  first
          resetRouter();
          commit("RESET_STATE");
          localStorage.setItem("template_style", "");
          localStorage.removeItem("menutree");
          localStorage.removeItem("is_sys");
          localStorage.removeItem("group_id");
          localStorage.removeItem("hotel_no");
          localStorage.removeItem("account_list");
          resolve();
          const url = window.location.href;
          const data = url.split("/");
          const newlist = data[0] + "/" + data[1] + "/" + data[2];
          // console.log('newlist:',newlist)
          window.location.href = newlist;
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  }
};

export default {
  namespaced: true, // namespaced: true 的方式使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接。
  state,
  mutations,
  actions
};
